import { CSSProperties } from 'react'

const backupRatio = 0.5
const DEFAULT_FONT_FAMILY = '"Avenir Next", sans-serif'

/**
 * Get text innerWidth by font
 */
export const getTextWidthInPx = (
  text: string,
  fontSize: number,
  fontWeight?: CSSProperties['fontWeight'],
  fontFamily = DEFAULT_FONT_FAMILY,
) => {
  const container = document.createElement('canvas')

  let width = 0
  const context = container.getContext('2d')

  const font = `${fontWeight} ${fontSize}px ${fontFamily}`

  if (context) {
    context.font = font
    width = context.measureText(text).width
    return width
  } else {
    // if something goes wrong mounting the canvas
    return fontSize * backupRatio * text.length
  }
}

/**
 * Get the max width of texts in pixels
 */
export const getMaxTextsWidthInPxFn = ({
  fontFamily = DEFAULT_FONT_FAMILY,
  fontSize,
  fontWeight,
  texts,
}: {
  texts: string[]
  fontSize: number
  fontWeight: CSSProperties['fontWeight']
  fontFamily?: string
}) => {
  return texts.reduce((acc, label) => {
    const labelWidth = getTextWidthInPx(label, fontSize, fontWeight, fontFamily)
    return Math.max(acc, labelWidth)
  }, 0)
}

/**
 * Get the label with plural
 * Add an 's' to the label if it doesn't already have one
 * @param label - The label to add the plural to
 */
export const getLabelWithPluralFn = (label: string) => {
  const lastChar = label[label.length - 1]

  // if the last character is already an 's' or not a letter, return the label
  if (lastChar === 's' || !lastChar.match(/[a-zA-Z]/)) {
    return label
  }

  return `${label}s`
}

/**
 * Get the label with singular
 * Remove an 's' from the label if it has one
 * @param label - The label to remove the plural from
 */
export const getLabelWithSingularFn = (label: string) => {
  const lastChar = label[label.length - 1]

  return lastChar === 's' ? label.slice(0, -1) : label
}

/**
 * Capitalize the first letter of a string
 * @param text - The text to capitalize
 */
export const icFirstFn = (text: string) => {
  if (!text) {
    return text
  }

  return `${text.charAt(0).toUpperCase()}${text.slice(1)}`
}
